import { graphql } from '@apollo/react-hoc';
import gql from 'graphql-tag';
import get from 'lodash/get';
import config from '../../../../config';

const DEFAULT_LOCALE = config('defaultLocale');

const withArtistRecommendations = Component =>
  graphql(
    gql`
  query withArtistRecommendations($limit: Int, $workImageWidth: Int, $locale: String, $followedIds: [Int!]) {
    artistRecommendations(limit: $limit, method: default, followedIds: $followedIds) {
      ...${Component.displayName}
    }
  }
  ${Component.fragment}
`,
    {
      props: ({
        data: { artistRecommendations, loading, error, refetch },
        ownProps
      }) => {
        let recommendations = artistRecommendations || [];
        recommendations = recommendations.filter(
          ({ recommendedArtist, recommendedWork }) => {
            return recommendedArtist !== null && recommendedWork !== null;
          }
        );

        return {
          ...ownProps,
          loading,
          error,
          refetch,
          artistRecommendations: recommendations
        };
      },
      options: ({ limit, workImageWidth, userInfo, userAccount }) => {
        const locale = get(userInfo, 'locale', DEFAULT_LOCALE);

        return {
          variables: {
            limit,
            workImageWidth,
            locale,
            followedIds: get(userAccount, 'followedIds')
          },
          errorPolicy: 'all',
          ssr: false
        };
      }
    }
  )(Component);

withArtistRecommendations.displayName = 'withArtistRecommendations';

export default withArtistRecommendations;
